import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Seo, { breadcrumbSchema } from "@/components/Seo";
import PageHero from "@/components/shared/PageHero";
import CtaSection from "@/components/shared/CtaSection";
import DynamicIcon from "@/components/shared/DynamicIcon";
import { Stagger, StaggerItem } from "@/components/motion/Reveal";
import { SERVICES } from "@/data/services";

export default function ServicesHub() {
  const itemList = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    itemListElement: SERVICES.map((s, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: s.title,
      url: `https://compubrain.ai/services/${s.slug}`,
    })),
  };
  return (
    <>
      <Seo
        title="GEO Services — Generative Engine Optimization Consulting"
        description="Explore CompuBrain AI's complete GEO service catalogue: Generative Engine Optimization, AI Visibility Audit, Entity SEO, Technical GEO, Schema Implementation, AI Citation Building and more."
        path="/services"
        schemas={[itemList, breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Services", path: "/services" }])]}
      />
      <PageHero
        eyebrow="Our GEO Services"
        titleLines={["Everything you need", "to win AI search."]}
        sub="Strategy, technical implementation and authority building — a complete capability dedicated exclusively to Generative Engine Optimization."
        breadcrumbs={[{ name: "Home", path: "/" }, { name: "Services" }]}
      />
      <section className="max-w-7xl mx-auto px-6 lg:px-12 py-20 lg:py-28">
        <Stagger className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s) => (
            <StaggerItem key={s.slug}>
              <Link
                to={`/services/${s.slug}`}
                data-testid={`service-hub-card-${s.slug}`}
                className="group flex flex-col h-full rounded-2xl border border-gray-200 p-8 hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(0,0,0,0.06)] hover:border-gray-300 transition-all duration-500"
              >
                <div className="h-12 w-12 rounded-xl bg-[#0B63F6]/[0.08] flex items-center justify-center text-[#0B63F6] group-hover:bg-[#0B63F6] group-hover:text-white transition-colors">
                  <DynamicIcon name={s.icon} className="h-6 w-6" />
                </div>
                <h2 className="font-display text-xl font-bold tracking-tight mt-6">{s.title}</h2>
                <p className="text-[15px] text-gray-600 mt-3 leading-relaxed flex-1">{s.short}</p>
                <span className="mt-6 inline-flex items-center gap-1 text-sm font-medium text-[#0B63F6]">
                  Explore service <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </Link>
            </StaggerItem>
          ))}
        </Stagger>
      </section>
      <CtaSection heading="Not sure which service you need?" sub="Start with an AI Visibility Audit — we'll show you exactly where the biggest gains are." />
    </>
  );
}
